import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d9997018-d2c1-4f07-9f6e-2514e4609cb0";
export const REGISTER_URL = "https://a.ntrk2.com/4589415c-6b68-4410-bb8d-b424a55a4446";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://hotpk.loadprkw2a.com/download?openExternalBrowser=1&id=kd5twq233qof2u8";

export * from "./codes";
export * from "./context";
